/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobExecutionStatusRequest {
    getFixupPrototypeFunction() { return PolicyJobExecutionStatusRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobExecutionStatusRequest>): PolicyJobExecutionStatusRequest {
        let obj = Object.assign(new PolicyJobExecutionStatusRequest(), model);
        PolicyJobExecutionStatusRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobExecutionStatusRequest>): PolicyJobExecutionStatusRequest {
        if (!model) return null;
        return PolicyJobExecutionStatusRequest.newInstance(<PolicyJobExecutionStatusRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobExecutionStatusRequest) {
        if (!obj) return;

        models.PolicyJobExecutionStatusRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobExecutionStatusRequest): boolean {
        Object.setPrototypeOf(obj, PolicyJobExecutionStatusRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the assessment_job_number.This can be fetched from List Compliance Control Assessment History API.
     */
    assessment_job_number: string;

    /**
     * Specify the policy ID. This can be fetched from List compliance control mapping, get_on_audit_entries API.
     */
    policy_id: string;

}
